import { ENVIRONMENT } from "./environment"

const stngs = {
	DEVELOPMENT: {
		general: {
			ApiBaseUrl: 'https://dev.frankwatching.com'
		}
	},
	ACCEPTANCE: {
		general: {
			ApiBaseUrl: 'https://acc.frankwatching.com'
		}
	},
	PRODUCTION: {
		general: {
			ApiBaseUrl: 'https://www.frankwatching.com'
		}
	}
};

export const settings = stngs[ENVIRONMENT];


// WEBPACK FOOTER //
// ./src/config/general.js